import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { fetchSavedSearches } from 'src/actions/savedSearches'
import { selectCustomerId } from 'src/store/selectors/customerProfile'
import { selectFilter } from 'src/store/selectors/filters'
import { selectClientIsGuest } from 'src/store/selectors/client'
import { selectSavedSearches } from 'src/store/selectors/savedSearches'
import { RemoveAlertButton } from './RemoveAlertButton/RemoveAlertButton'
import { ConfirmAlertButton } from './ConfirmAlertButton/ConfirmAlertButton'

export const AlertToggle = () => {
  const dispatch = useDispatch()
  const clientIsGuest = useSelector(selectClientIsGuest)
  const customerId = useSelector(selectCustomerId)
  const filters = useSelector(selectFilter)
  const savedSearches = useSelector(selectSavedSearches)
  const [isCurrentSearchSaved, setIsCurrentSearchSaved] = useState(false)

  useEffect(() => {
    if (!clientIsGuest) {
      dispatch(fetchSavedSearches(customerId))
    }
  }, [dispatch, clientIsGuest, customerId])

  useEffect(() => {
    if (!clientIsGuest) {
      setIsCurrentSearchSaved(
        !!savedSearches?.some(
          savedSearch => savedSearch?.locationId === filters?.location?.id
        )
      )
    }
  }, [clientIsGuest, savedSearches, filters])

  return (
    <>
      {isCurrentSearchSaved && <RemoveAlertButton />}
      {!isCurrentSearchSaved && <ConfirmAlertButton />}
    </>
  )
}
